import {
    EntityType,
    LinkedContentContract,
} from '@polaris-customerweb/sharedcomponents.core';
import { UserContentItem } from '@polaris-customerweb/sharedcomponents.user-content';
import { cloneDeep } from 'lodash-es';

export class LinkedItem {
    private _modificationDate: Date = new Date();
    private _rawItem: LinkedContentContract;

    constructor(dto?: LinkedContentContract) {
        if (!dto) {
            this._rawItem = {
                entityType: 'Unknown',
                id: '',
                modificationDate: '',
                ownerRiderId: '',
            };
            return;
        }

        this._rawItem = cloneDeep(dto);
    }

    get entityType(): EntityType {
        return this._rawItem.entityType ?? 'Unknown';
    }

    get ownerRiderId(): string {
        return this._rawItem.ownerRiderId || '';
    }

    get modificationDate(): Date {
        if (!this._modificationDate) {
            this._modificationDate = new Date(
                this._rawItem.modificationDate || ''
            );
        }

        return this._modificationDate;
    }

    get id(): string {
        return this._rawItem.id ?? '';
    }

    static fromUserContentItem(userContent: UserContentItem): LinkedItem {
        return new LinkedItem({
            entityType: userContent.type,
            id: userContent.id,
            ownerRiderId: userContent.riderId,
        });
    }

    toDto(): LinkedContentContract {
        return cloneDeep(this._rawItem);
    }
}
